import ScrollToHashElement from "../Util/ScrollToHashElement";
import { Outlet } from "react-router-dom";

const RootLayout = () => {
  return (
    <>
      <ScrollToHashElement />
      <Outlet />
    </>
  );
};

export default RootLayout;
